module.exports = __webpack_public_path__ + "static/img/printkupinstall3.84d025f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/printkupinstall3.png
// module id = viDI
// module chunks = 0